import { KeyValuePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Subject } from 'rxjs';
import { Subcontractor } from './../../../../../../_shared/model/subcontractor.model';
import { StorageService } from './../../../../../../_shared/services/storage.service';
import { CommonService } from './../../../_services/common.service';
import { ConfigGUIService } from './../../../_services/configGUI.service';

@Component({
    selector: 'cal-subs-list',
    templateUrl: './main-cal-subs-list.component.html',
    styles: [],
})
export class MainCalSubsListComponent implements OnInit, OnChanges {
    @Input()
    allSubcontractors: Subcontractor[];

    @Input()
    selectedSubconstractors: Subcontractor[] = [];

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onChangeSelect: Subject<Subcontractor[]> = new Subject();

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public changeSubcontractorFilter: Subject<any> = new Subject();

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public allSubcontractorsGroupd: any = {};
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public allGroupTags: any = {};

    constructor(
        private keyvalue: KeyValuePipe,
        private configGUIRest: ConfigGUIService,
        private storage: StorageService,
        private commonRest: CommonService,
        private store: Store,
    ) {}

    ngOnInit() {
        this.initSubcontractors();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.allSubcontractors) {
            this.initSubcontractors();
        }
    }

    initSubcontractors() {
        this.allSubcontractorsGroupd = {};
        this.allSubcontractors.map(sub => {
            if (sub.groupTags.length < 1) {
                if (!_.has(this.allSubcontractorsGroupd, 'Brez skupine')) {
                    this.allSubcontractorsGroupd['Brez skupine'] = [];
                }
                this.allSubcontractorsGroupd['Brez skupine'].push(sub);
            } else {
                sub.groupTags.map(tag => {
                    if (!_.has(this.allSubcontractorsGroupd, tag.name)) {
                        this.allSubcontractorsGroupd[tag.name] = [];
                    }
                    this.allSubcontractorsGroupd[tag.name].push(sub);
                    _.set(this.allGroupTags, tag.name, true);
                });
            }
            if (!sub.active) {
                if (this.allSubcontractorsGroupd['Neaktivni']) {
                    this.allSubcontractorsGroupd['Neaktivni'].push(sub);
                } else {
                    this.allSubcontractorsGroupd['Neaktivni'] = [];
                    this.allSubcontractorsGroupd['Neaktivni'].push(sub);
                }
            }
        });

        //Neaktivni ne smejo biti v skupini [Brez skupine]
        if (this.allSubcontractorsGroupd['Brez skupine']) {
            for (let i = 0; i < this.allSubcontractorsGroupd['Brez skupine'].length; i++) {
                if (!this.allSubcontractorsGroupd['Brez skupine'][i].active) {
                    this.allSubcontractorsGroupd['Brez skupine'].splice(i, 1);
                }
            }
        }
        this.initGroupIfSelected();
    }

    public checkIfSelectedSubcontractor(subcontractor: Subcontractor): boolean {
        if (this.selectedSubconstractors.find(sub => sub.id === subcontractor.id)) {
            return true;
        }
        return false;
    }

    private initGroupIfSelected(): void {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        for (const iterator of <any[]>this.keyvalue.transform(this.allSubcontractorsGroupd)) {
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ((<any[]>iterator.value).every(el => this.selectedSubconstractors.map(el => el.id).indexOf(el.id) !== -1)) {
                this.allGroupTags[iterator.key] = true;
            } else {
                this.allGroupTags[iterator.key] = false;
            }
        }
    }

    public changeSubcontractorFilterLocal(data): void {
        if (data.event.target.checked) {
            this.selectedSubconstractors = [...(this.selectedSubconstractors || []), data.value];
        } else {
            // filter kreira nov array in izgubimo referenco
            // const removeAtIndex = this.selectedSubconstractors.findIndex((el) => data.value.id === el.id);
            // this.selectedSubconstractors.splice(removeAtIndex, 1);
            this.selectedSubconstractors = this.selectedSubconstractors.filter(el => el.id != data.value.id);
        }

        this.configGUIRest.updateUserGuiCalendarSubcontractors(this.storage.getSelectedContractor().id, this.selectedSubconstractors);

        this.initGroupIfSelected();

        this.changeSubcontractorFilter.next(this.selectedSubconstractors);

        // this.onChangeSelect.next(this.selectedSubconstractors);
    }

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onChangeSelectLocal(activeSubcontractors?: Subcontractor[], event?: any): void {
        if (activeSubcontractors) {
            if (event.target.checked) {
                this.selectedSubconstractors = _.unionBy(this.selectedSubconstractors, activeSubcontractors, 'id');
            } else {
                this.selectedSubconstractors = _.differenceBy(this.selectedSubconstractors, activeSubcontractors, 'id');
            }
        } else {
            if (this.selectedSubconstractors && this.allSubcontractors && this.selectedSubconstractors.length !== this.allSubcontractors.length) {
                this.selectedSubconstractors = [];
                this.selectedSubconstractors = [...(this.allSubcontractors || [])];
            } else {
                this.selectedSubconstractors = [];
            }
        }

        this.configGUIRest.updateUserGuiCalendarSubcontractors(this.storage.getSelectedContractor().id, this.selectedSubconstractors);
        this.initGroupIfSelected();
        this.onChangeSelect.next(this.selectedSubconstractors);
    }
}
